export class Config {
  static assetConfigData: any;
}
